module.exports = __webpack_public_path__ + "static/media/balance_250000_500000.e2a756d2.png";